import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevron = (props) => (_jsx("svg", { viewBox: "0 0 13 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...props, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m.5 1.4 1-1 5 5.1 5-5 1 1-6 6-6-6z", fill: "currentColor" }) }));
export default SvgChevron;
